"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.sync = exports.scanAccounts = exports.postSync = exports.getOperationStatus = exports.getSubAccountShape = exports.getSubAccounts = exports.getAccountShape = void 0;
var logs_1 = require("@ledgerhq/logs");
var logic_1 = require("./logic");
var etherscan_1 = __importDefault(require("./api/etherscan"));
var jsHelpers_1 = require("../../bridge/jsHelpers");
var account_1 = require("../../account");
var rpc_1 = require("./api/rpc");
/**
 * Switch to select one of the compatible explorer
 */
var getExplorerApi = function (currency) {
    var _a, _b;
    var apiType = (_b = (_a = currency.ethereumLikeInfo) === null || _a === void 0 ? void 0 : _a.explorer) === null || _b === void 0 ? void 0 : _b.type;
    switch (apiType) {
        case "etherscan":
        case "blockscout":
            return etherscan_1["default"];
        default:
            throw new Error("API type not supported");
    }
};
/**
 * Main synchronization process
 * Get the main Account and the potential TokenAccounts linked to it
 */
var getAccountShape = function (infos) { return __awaiter(void 0, void 0, void 0, function () {
    var initialAccount, address, derivationMode, currency, _a, blockHeight, balance, accountId, syncHash, shouldSyncFromScratch, latestSyncedOperation, lastCoinOperations, newSubAccounts, subAccounts, confirmPendingOperations, confirmedOperations, newOperations, operations, lastSyncDate;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                initialAccount = infos.initialAccount, address = infos.address, derivationMode = infos.derivationMode, currency = infos.currency;
                return [4 /*yield*/, (0, rpc_1.getBalanceAndBlock)(currency, address)];
            case 1:
                _a = _d.sent(), blockHeight = _a.blockHeight, balance = _a.balance;
                accountId = (0, account_1.encodeAccountId)({
                    type: "js",
                    version: "2",
                    currencyId: currency.id,
                    xpubOrAddress: address,
                    derivationMode: derivationMode
                });
                syncHash = (0, logic_1.getSyncHash)(currency);
                shouldSyncFromScratch = syncHash !== (initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.syncHash);
                latestSyncedOperation = shouldSyncFromScratch
                    ? null
                    : (_b = initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.operations) === null || _b === void 0 ? void 0 : _b.reduce(function (acc, curr) {
                        if (!acc) {
                            return curr;
                        }
                        return ((acc === null || acc === void 0 ? void 0 : acc.blockHeight) || 0) > ((curr === null || curr === void 0 ? void 0 : curr.blockHeight) || 0) ? acc : curr;
                    }, null);
                return [4 /*yield*/, (function () { return __awaiter(void 0, void 0, void 0, function () {
                        var getLastCoinOperations, e_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    getLastCoinOperations = getExplorerApi(currency).getLastCoinOperations;
                                    return [4 /*yield*/, getLastCoinOperations(currency, address, accountId, (latestSyncedOperation === null || latestSyncedOperation === void 0 ? void 0 : latestSyncedOperation.blockHeight) || 0)];
                                case 1: return [2 /*return*/, _a.sent()];
                                case 2:
                                    e_1 = _a.sent();
                                    (0, logs_1.log)("EVM Family", "Failed to get latest transactions", {
                                        address: address,
                                        currency: currency,
                                        error: e_1
                                    });
                                    throw e_1;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); })()];
            case 2:
                lastCoinOperations = _d.sent();
                return [4 /*yield*/, (0, exports.getSubAccounts)(infos, accountId, shouldSyncFromScratch)];
            case 3:
                newSubAccounts = _d.sent();
                subAccounts = (0, logic_1.mergeSubAccounts)(initialAccount, newSubAccounts);
                confirmPendingOperations = ((_c = initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.pendingOperations) === null || _c === void 0 ? void 0 : _c.map(function (op) {
                    return (0, exports.getOperationStatus)(currency, op);
                })) || [];
                return [4 /*yield*/, Promise.all(confirmPendingOperations).then(function (ops) { return ops.filter(function (op) { return !!op; }); })];
            case 4:
                confirmedOperations = _d.sent();
                newOperations = __spreadArray(__spreadArray([], __read(confirmedOperations), false), __read(lastCoinOperations), false);
                operations = (0, jsHelpers_1.mergeOps)((initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.operations) || [], newOperations);
                lastSyncDate = new Date();
                return [2 /*return*/, {
                        type: "Account",
                        id: accountId,
                        syncHash: syncHash,
                        balance: balance,
                        spendableBalance: balance,
                        blockHeight: blockHeight,
                        operations: operations,
                        operationsCount: operations.length,
                        subAccounts: subAccounts,
                        lastSyncDate: lastSyncDate
                    }];
        }
    });
}); };
exports.getAccountShape = getAccountShape;
/**
 * Getting all token related operations in order to provide TokenAccounts
 */
var getSubAccounts = function (infos, accountId, shouldSyncFromScratch) {
    if (shouldSyncFromScratch === void 0) { shouldSyncFromScratch = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var initialAccount, address, currency, latestSyncedOperation, lastERC20OperationsAndCurrencies, erc20OperationsByToken, subAccountsPromises, _a, _b, _c, token, ops;
        var e_2, _d;
        var _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    initialAccount = infos.initialAccount, address = infos.address, currency = infos.currency;
                    latestSyncedOperation = shouldSyncFromScratch
                        ? null
                        : (_e = initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.subAccounts) === null || _e === void 0 ? void 0 : _e.flatMap(function (_a) {
                            var operations = _a.operations;
                            return operations;
                        }).reduce(function (acc, curr) {
                            if (!acc) {
                                return curr;
                            }
                            return ((acc === null || acc === void 0 ? void 0 : acc.blockHeight) || 0) > ((curr === null || curr === void 0 ? void 0 : curr.blockHeight) || 0)
                                ? acc
                                : curr;
                        }, null);
                    return [4 /*yield*/, (function () { return __awaiter(void 0, void 0, void 0, function () {
                            var getLastTokenOperations, e_3;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        getLastTokenOperations = getExplorerApi(currency).getLastTokenOperations;
                                        return [4 /*yield*/, getLastTokenOperations(currency, address, accountId, (latestSyncedOperation === null || latestSyncedOperation === void 0 ? void 0 : latestSyncedOperation.blockHeight) || 0)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                    case 2:
                                        e_3 = _a.sent();
                                        (0, logs_1.log)("EVM Family", "Failed to get latest ERC20 transactions", {
                                            address: address,
                                            currency: currency,
                                            error: e_3
                                        });
                                        throw e_3;
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); })()];
                case 1:
                    lastERC20OperationsAndCurrencies = _f.sent();
                    erc20OperationsByToken = lastERC20OperationsAndCurrencies.reduce(function (acc, _a) {
                        var _b;
                        var tokenCurrency = _a.tokenCurrency, operation = _a.operation;
                        if (!tokenCurrency)
                            return acc;
                        if (!acc.has(tokenCurrency)) {
                            acc.set(tokenCurrency, []);
                        }
                        (_b = acc.get(tokenCurrency)) === null || _b === void 0 ? void 0 : _b.push(operation);
                        return acc;
                    }, new Map());
                    subAccountsPromises = [];
                    try {
                        for (_a = __values(erc20OperationsByToken.entries()), _b = _a.next(); !_b.done; _b = _a.next()) {
                            _c = __read(_b.value, 2), token = _c[0], ops = _c[1];
                            subAccountsPromises.push((0, exports.getSubAccountShape)(currency, accountId, token, ops));
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_b && !_b.done && (_d = _a["return"])) _d.call(_a);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    return [2 /*return*/, Promise.all(subAccountsPromises)];
            }
        });
    });
};
exports.getSubAccounts = getSubAccounts;
/**
 * Fetch the balance for a token and creates a TokenAccount based on this and the provided operations
 */
var getSubAccountShape = function (currency, parentId, token, operations) { return __awaiter(void 0, void 0, void 0, function () {
    var address, tokenAccountId, balance;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                address = (0, account_1.decodeAccountId)(parentId).xpubOrAddress;
                tokenAccountId = (0, account_1.encodeTokenAccountId)(parentId, token);
                return [4 /*yield*/, (0, rpc_1.getTokenBalance)(currency, address, token.contractAddress)];
            case 1:
                balance = _a.sent();
                return [2 /*return*/, {
                        type: "TokenAccount",
                        id: tokenAccountId,
                        parentId: parentId,
                        token: token,
                        balance: balance,
                        spendableBalance: balance,
                        creationDate: new Date(),
                        operations: operations,
                        operationsCount: operations.length,
                        pendingOperations: [],
                        balanceHistoryCache: account_1.emptyHistoryCache
                    }];
        }
    });
}); };
exports.getSubAccountShape = getSubAccountShape;
/**
 * Get a finalized operation depending on it status (confirmed or not)
 */
var getOperationStatus = function (currency, op) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, blockHeight_1, blockHash, timestamp_1, nonce, date, e_4;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                return [4 /*yield*/, (0, rpc_1.getTransaction)(currency, op.hash)];
            case 1:
                _a = _b.sent(), blockHeight_1 = _a.blockNumber, blockHash = _a.blockHash, timestamp_1 = _a.timestamp, nonce = _a.nonce;
                if (!blockHeight_1) {
                    throw new Error("getOperationStatus: Transaction has no block");
                }
                return [4 /*yield*/, (function () { return __awaiter(void 0, void 0, void 0, function () {
                        var blockTimestamp;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    // timestamp can be missing depending on the node
                                    if (timestamp_1) {
                                        return [2 /*return*/, new Date(timestamp_1 * 1000)];
                                    }
                                    return [4 /*yield*/, (0, rpc_1.getBlock)(currency, blockHeight_1)];
                                case 1:
                                    blockTimestamp = (_a.sent()).timestamp;
                                    return [2 /*return*/, new Date(blockTimestamp * 1000)];
                            }
                        });
                    }); })()];
            case 2:
                date = _b.sent();
                return [2 /*return*/, __assign(__assign({}, op), { transactionSequenceNumber: nonce, blockHash: blockHash, blockHeight: blockHeight_1, date: date })];
            case 3:
                e_4 = _b.sent();
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.getOperationStatus = getOperationStatus;
/**
 * After each sync, it might be necessary to remove pending operations
 * inside of subAccounts.
 */
var postSync = function (initial, synced) {
    var e_5, _a, e_6, _b;
    var _c;
    // Set of hashes from the pending operations of the main account
    var coinPendingOperationsHashes = new Set();
    try {
        for (var _d = __values(synced.pendingOperations), _e = _d.next(); !_e.done; _e = _d.next()) {
            var coinPendingOperation = _e.value;
            coinPendingOperationsHashes.add(coinPendingOperation.hash);
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_a = _d["return"])) _a.call(_d);
        }
        finally { if (e_5) throw e_5.error; }
    }
    // Set of ids from the already existing subAccount from previous sync
    var initialSubAccountsIds = new Set();
    try {
        for (var _f = __values(initial.subAccounts || []), _g = _f.next(); !_g.done; _g = _f.next()) {
            var subAccount = _g.value;
            initialSubAccountsIds.add(subAccount.id);
        }
    }
    catch (e_6_1) { e_6 = { error: e_6_1 }; }
    finally {
        try {
            if (_g && !_g.done && (_b = _f["return"])) _b.call(_f);
        }
        finally { if (e_6) throw e_6.error; }
    }
    return __assign(__assign({}, synced), { subAccounts: (_c = synced.subAccounts) === null || _c === void 0 ? void 0 : _c.map(function (subAccount) {
            // If the subAccount is new, just return the freshly synced subAccount
            if (!initialSubAccountsIds.has(subAccount.id))
                return subAccount;
            return __assign(__assign({}, subAccount), { pendingOperations: subAccount.pendingOperations.filter(function (tokenPendingOperation) {
                    // if the pending operation got removed from the main account, remove it as well
                    return coinPendingOperationsHashes.has(tokenPendingOperation.hash) &&
                        // if the transaction has been confirmed, remove it
                        !subAccount.operations.some(function (op) { return op.hash === tokenPendingOperation.hash; }) &&
                        // common rule for pending operations retention in the live
                        (0, account_1.shouldRetainPendingOperation)(synced, tokenPendingOperation);
                }) });
        }) });
};
exports.postSync = postSync;
exports.scanAccounts = (0, jsHelpers_1.makeScanAccounts)({ getAccountShape: exports.getAccountShape });
exports.sync = (0, jsHelpers_1.makeSync)({
    getAccountShape: exports.getAccountShape,
    postSync: exports.postSync,
    shouldMergeOps: false
});
//# sourceMappingURL=synchronization.js.map